import { registerAction } from '../../Action'
import { AssignmentsActions } from './AssignmentsActions'

const updateNestedState = (state, view, updates) => ({
  ...state,
  entityDataByView: {
    ...(state.entityDataByView && state.entityDataByView),
    [view]: {
      ...(state.entityDataByView && state.entityDataByView[view]),
      ...updates,
    },
  },
})

const fetchAssignmentsRequestReducer = (state = {}, action) =>
  updateNestedState(state, action.payload.view, {
    fetching: true,
  })

const fetchAssignmentsSuccessReducer = (state = {}, action) =>
  updateNestedState(state, action.payload.view, {
    fetching: false,
  })

const fetchAssignmentsErrorReducer = (state = {}, action) =>
  updateNestedState(state, action.payload.view, {
    assignmentsError: action.payload.error,
    fetching: false,
  })

export const fetchAssignmentsRequest = registerAction(
  AssignmentsActions.FETCH_ALL_ASSIGNMENTS_REQUEST,
  { reducer: fetchAssignmentsRequestReducer }
)
export const fetchAssignmentsSuccess = registerAction(
  AssignmentsActions.FETCH_ALL_ASSIGNMENTS_SUCCESS,
  { reducer: fetchAssignmentsSuccessReducer }
)
export const fetchAssignmentsError = registerAction(
  AssignmentsActions.FETCH_ALL_ASSIGNMENTS_ERROR,
  { reducer: fetchAssignmentsErrorReducer }
)

export default {
  fetchAssignmentsError,
  fetchAssignmentsRequest,
  fetchAssignmentsSuccess,
}
